import { c as _c } from "react/compiler-runtime";
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import type { LocationParams } from "src/lib/program/LocationParams";
import { NFK_LOCATIONS } from "src/lib/program/nfkLocations";
import { useProgramSearchParams } from "src/lib/program/useProgramSearchParams";

// src/lib/program/useProgramLocationParams.ts
export function getProgramLocationParams(firmId: number | null, location: string[] | null, isAdFree?: boolean, adFreeSkin?: string | null) {
  let locationParams: LocationParams;
  if (firmId !== null) {
    locationParams = {
      firmId
    };
  } else if (isAdFree && adFreeSkin === "nfk") {
    const loc = NFK_LOCATIONS.find(loc => (location ?? []).includes(loc.location));
    locationParams = {
      firmId: loc?.firmId ?? 3
    }; // fallback to make sure we get valid data
  } else {
    locationParams = {
      locations: location
    };
  }
  return {
    locationParams,
    atLeastOneLocationSelected: (location?.length ?? 0) > 0 || firmId !== null
  };
}

/** reads the url - call it inside <Suspense> */
export function useProgramLocationParams(isAdFree, adFreeSkin) {
  const $ = _c(5);
  const {
    firmId
  } = useProgramSearchParams();
  const {
    location
  } = useLocationContext();
  let t0;
  if ($[0] !== adFreeSkin || $[1] !== firmId || $[2] !== isAdFree || $[3] !== location) {
    t0 = getProgramLocationParams(firmId, location, isAdFree, adFreeSkin);
    $[0] = adFreeSkin;
    $[1] = firmId;
    $[2] = isAdFree;
    $[3] = location;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}